<template>
  <div class="filter-profession-container">
    <cube-scroll :data="industriesData" @scroll="scrollHandler" :scroll-events="[ 'scroll' ]" ref="professionScroll">
      <div class="profession-content-body">
        <p class="block-title">校招类型</p>
        <div class="flex-start campus-type">
          <div v-for="(item, index) in infoTypeEnum" :key="index" @click="changeInfoType(item)"
               class="campus-type-item flex-center" :class="{'campus-type-item-active': item.text === infoType}">{{item.text}}</div>
        </div>
        <p class="block-title">行业领域</p>
        <div class="profession-content">
          <template v-for="(item, index) in industriesData">
            <div class="profession-item flex-center" :key="index" @click="pickProfession(item)"
                :class="{ 'profession-item-active': professionCode === item.code }">
              {{ item.name }}
            </div>
          </template>
        </div>
      </div>
    </cube-scroll>
  </div>
</template>

<script>
  import { industries } from '../../../assets/json/conditions.json'
  export default {
    name: 'filter-profession',
    props: {
      filterValue: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        professionCode: '',
        infoType: '不限',
        scrollY: ''
      }
    },
    mounted() {},
    computed: {
      industriesData() {
        return JSON.parse(JSON.stringify(industries))
      },
      infoTypeEnum() {
        return [
          { text: '不限', value: 0 },
          { text: '实习', value: 1 },
          { text: '校招', value: 2 }
        ]
      }
    },
    watch: {
      filterValue(val) {
        if (val) {
          this.$refs.professionScroll.refresh()
          this.$refs.professionScroll.scrollTo(0, this.scrollY)
        }
      }
    },
    components: {},
    methods: {
      // 滚动事件
      scrollHandler({ y }) {
        this.scrollY = y
      },
      pickProfession(item) {
        this.professionCode = item.code
        this.$emit('changeProfessionCode', item)
      },
      changeInfoType(item) {
        this.infoType = item.text
        this.$emit('changeInfoType', item)
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/scss/global/variable";
  @import "../../../assets/scss/global/mixin";
  .filter-profession-container {
    width: 100vw;
    padding: 16px 8px 0 16px;
    background-color: $color-light;
    height: 445px;
    .profession-content-body {
      .block-title {
        color: $color-dark-gray;
        margin-bottom: 12px; 
      }
      .campus-type {
        margin-bottom: 16px;
        .campus-type-item {
          flex: 1;
          margin-right: 10px;
          background-color: #F9F9F9;
          border-radius: 3px;
          color: $color-dark-gray;
          border: 1px solid transparent;
          font-weight: 500;
          height: 38px;
          &:last-child {
            margin-right: 0;
          }
          &-active {
            background-color: $color-light;
            color: $color-theme;
            border: 1px solid $color-theme;
          }
        }
      }
    }
    .profession-content {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      margin-bottom: 16px;
      .profession-item {
        width: 47%;
        height: 38px;
        margin-right: 8px;
        margin-bottom: 9px;
        background-color: #F9F9F9;
        border-radius: 3px;
        color: $color-dark-gray;
        border: 1px solid transparent;
        font-weight: 500;
        &-active {
          background-color: $color-light;
          color: $color-theme;
          border: 1px solid $color-theme;
        }
      }
    }
  }
</style>